import Layout from "../components/Layout";
import Hero from "../components/home/Hero";
import AboutPreview from "../components/home/AboutPreview";
import FeaturedServices from "../components/home/FeaturedServices";
import WhyChooseUs from "../components/home/WhyChooseUs";
import Testimonials from "../components/home/Testimonials";
import CallToAction from "../components/CallToAction";

const HomePage = () => {
  return (
    <Layout withPadding={false}>
      <Hero />
      <AboutPreview />
      <FeaturedServices />
      <WhyChooseUs />
      <Testimonials />
      <CallToAction />
    </Layout>
  );
};

export default HomePage;